import React from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { Layout } from './Layout'
import { LoadingSpinner } from '../ui/LoadingSpinner'

export const RegularUserLayout: React.FC = () => {
  const { user, isAuthenticated } = useAuth()
  const navigate = useNavigate()

  React.useEffect(() => {
    if (isAuthenticated && user?.isAdmin) {
      navigate('/app/admin', { replace: true })
    }
  }, [user, isAuthenticated, navigate])

  // Show loading while checking admin status
  if (isAuthenticated && user?.isAdmin) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  return <Layout />
}




